import { useQuery } from '@tanstack/react-query';
import { fetchDropdownDataList } from 'apis/story/missionApis';
import { IDropListProps } from 'utils/types/common';

function useEpisodeDropQuery(projectId) {
  const { status, data, error, isFetching } = useQuery(
    ['episodeDropData', projectId],
    async () => await fetchDropdownDataList.episodeList(projectId),
    {
      select: (data) => {
        const newArr: IDropListProps[] = [];
        data?.map((v, i) =>
          newArr.push({
            key: i,
            text: v.title,
            value: v.episode_id,
          }),
        );

        return newArr;
      },
      onSuccess: (data) => {
        // console.log(data);
      },
    },
  );
  return { status, data, error, isFetching };
}

export default useEpisodeDropQuery;
